// C:\Projects\texe-web\src\main.tsx
import "./index.css";

import "./i18n";
import "./index.css"; // ⬅️ ÖNEMLİ: global stilleri yükle
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./context/AuthProvider";
import RealtimeProvider from "./context/RealtimeProvider";
import { PostInteractionsProvider } from "./context/PostInteractionsProvider";

// Query Provider
import { QueryProvider } from "./providers/QueryProvider";

// Linkify init (dinamik importlu); render’ı bunun ardından başlatacağız
import { linkifyInitPromise } from "./lib/initLinkify";

const rootEl = document.getElementById("root") as HTMLElement;
const root = ReactDOM.createRoot(rootEl);

// Linkify init bitince render et (top-level await kullanmadan)
linkifyInitPromise.finally(() => {
  root.render(
    <BrowserRouter>
      <AuthProvider>
        <RealtimeProvider>
          <PostInteractionsProvider>
            <QueryProvider>
              <App />
            </QueryProvider>
          </PostInteractionsProvider>
        </RealtimeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
});
